var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperationLowAnalyzer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 1.625H2.125V22.75C2.125 23.181 2.2962 23.5943 2.60095 23.899C2.9057 24.2038 3.31902 24.375 3.75 24.375H24.875V22.75H3.75V1.625Z",
    fill: "#186419"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.875 18.6875H19.1875V17.0625H22.1044L15.9375 10.8956L12.4519 14.3894C12.3763 14.4655 12.2865 14.526 12.1875 14.5672C12.0885 14.6085 11.9823 14.6297 11.875 14.6297C11.7677 14.6297 11.6615 14.6085 11.5625 14.5672C11.4635 14.526 11.3737 14.4655 11.2981 14.3894L5.375 8.45812L6.52062 7.3125L11.875 12.6669L15.3606 9.17313C15.4362 9.09697 15.526 9.03652 15.625 8.99528C15.724 8.95403 15.8302 8.93279 15.9375 8.93279C16.0448 8.93279 16.151 8.95403 16.25 8.99528C16.349 9.03652 16.4388 9.09697 16.5144 9.17313L23.25 15.9169V13H24.875V18.6875Z",
    fill: "#186419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationLowAnalyzer);
export default __webpack_public_path__ + "static/media/OperationLowAnalyzer.fb16a52a9550647d559dcbb6687dcdc2.svg";
export { ForwardRef as ReactComponent };